module.exports = __webpack_public_path__ + "static/media/SPINOX.0c8cf971.jpg";